import React from 'react'
import PropTypes from 'prop-types'
import { Margin, Text } from 'shared/components'

import BeneForm from './components/beneficiaryForm'

import * as styles from './styles'

const SignupComponent = ({ onSubmit }) => (
  <Margin resetWhen="phone" css={styles.signupContainer}>
    <section css={styles.signupSection}>
      <Margin as="section" bottom={2}>
        <Text as="h2" size={16} white italic bold>
          Express your interest
        </Text>
      </Margin>
      <Margin as="section" tb={2}>
        <BeneForm onSubmit={onSubmit} />
      </Margin>
    </section>
  </Margin>
)

SignupComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default SignupComponent
